import { Feature, EventEmitter } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { Events } from '@tencent/docs-titlebar-service';
import { usePrivateAuthMenu } from '@framework/workbench/ui/auth/config';

@Feature()
export class AuthFeature extends BaseTitleBarFeature {
    public constructor(private eventEmitter: EventEmitter) {
        super();
    }
    /**
     * 文档权限
     */
    public permissionSetting() {
        if (usePrivateAuthMenu) {
            this.getAppServices().viewableServiceLayer.extensionService?.getCallBackAdapter()?.onAuthClick?.();
        } else {
            // 需要先关闭侧边栏，否则会出现覆盖问题（第二次触发的侧边栏在第一次下面）
            this.getAppServices().viewableServiceLayer.extensionService?.hideRightSideBar();
            this.eventEmitter.emit(Events.SHOW_COOPERATION);
        }
    }

    /**
     * 高级权限
     */
    public advancedPermission() {
        this.getAppServices().editableServiceLayer?.advancedPermissionManager.showDialog();
    }

    /**
     * 设置水印
     */
    public setWatermark() {
        this.getMenuManager()?.actionSetWatermark();
    }

    /**
     * 转让文档所有权
     */
    public transferAuth() {
        this.getAppServices().editableServiceLayer?.transferAuthManager.promise().then((transferAuthManager) => {
            transferAuthManager.showTransferAuth();
        });
    }
}
